import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type DeletePlayerDialogProps = {
  player: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function DeletePlayerDialog({
  open,
  player,
  onClose,
  onConfirm,
}: Readonly<DeletePlayerDialogProps>) {
  const handleConfirm = () => {
    onClose();
    onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Remove player</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Remove <b>{player}</b> from this week game?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>No</Button>
        <Button onClick={handleConfirm} autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
